var map = {
	"./de.yml": 2702,
	"./en.yml": 134,
	"./es.yml": 3315,
	"./fc.yml": 258,
	"./fr.yml": 8011,
	"./hu.yml": 3450,
	"./it.yml": 6868,
	"./ja.yml": 3872,
	"./sp.yml": 9250
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6700;